import { render, staticRenderFns } from "./weight-editor.vue?vue&type=template&id=86fe620e&scoped=true&"
import script from "./weight-editor.vue?vue&type=script&lang=js&"
export * from "./weight-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86fe620e",
  null
  
)

export default component.exports